import { render, staticRenderFns } from "./UxWrapper.vue?vue&type=template&id=4bc32070&"
import script from "./UxWrapper.vue?vue&type=script&lang=js&"
export * from "./UxWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UxWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wolf/Documents/Apps/Trading/trading-vue-bundle/trading-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc32070')) {
      api.createRecord('4bc32070', component.options)
    } else {
      api.reload('4bc32070', component.options)
    }
    module.hot.accept("./UxWrapper.vue?vue&type=template&id=4bc32070&", function () {
      api.rerender('4bc32070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UxWrapper.vue"
export default component.exports